export function getByEventId() {
  return `
    query($eventId:String!){
      ticket {
        getByEventId(eventId: $eventId) {
          _id,
          code,
          status,
          promoterId,
          promoter{name,lastName}
          createdBy,
          activatedBy,
          note,
          totalCount,
          totalPrice, 
          totalPlatformFees,
          totalProcessingFees,
          ticketComponents{ticketBankId, count, price},
          chargeInfo,
          buyer{fullName,email},
          createdAt,
          updatedAt
        }
      }
    }
`;
}

export function activateNewPrivate() {
  return `mutation( $eventId: String!, $ticketComponents: [TicketComponentMinimal!]!, $notes: String! ) {
    ticket {
      activate(
        eventId: $eventId
        ticketComponents: $ticketComponents
        notes: $notes
      )
    }
  }`;
}

export function activatePrivateCode() {
  return `mutation( $eventId: String!, $ticketCode: String!, $ticketComponents: [TicketComponentMinimal!]!, $notes: String! ) {
    ticket {
      activate(
        eventId: $eventId
        ticketComponents: $ticketComponents
        ticketCode: $ticketCode
        notes: $notes
      )
    }
  }`;
}

export function checkInTicket() {
  return `mutation( $eventId: String!, $ticketCode: String!, $ticketComponents: [TicketComponentNormal!]!, $newCheckedIn: [TicketComponentMinimal!]! ) {
    ticket {
      checkIn(
        eventId: $eventId
        ticketComponents: $ticketComponents
        ticketCode: $ticketCode
        newCheckedIn: $newCheckedIn
      )
    }
  }`;
}

export function getByCode() {
  return `query( $ticketCode: String! ) {
    ticket {
      get( ticketCode: $ticketCode ){
        code,
        status,
        eventId,
        buyer {
          fullName
          email
        },
        totalPrice,
        ticketComponents {
          ticketBankId
          checkedIn
          count
          fee
          price
          name
        },
        totalPlatformFees,
        totalProcessingFees,
        createdAt
        boughtAt
        tax
        internationalCardUsed
        checkInLog {
          ticketBankId
          checkerName
          checkerEmail
          count
          checkedInAt
        }
      }
    }
  }`;
}

export function getByCodeEventIdOnly() {
  return `query( $ticketCode: String! ) {
    ticket {
      get( ticketCode: $ticketCode ){
        code,
        status,
        eventId
        promoterId
      }
    }
  }`;
}

export function decay() {
  return `
    mutation($code:String!){
      ticket {
        decay(code: $code)
      }
    }`;
}

export function purchase() {
  return `
    mutation(
      $ticketComponents: [TicketComponentMinimal!]!
      $stripeToken: String!,
      $ticketCode: String,
      $promoterId: String,
      $eventId:String!,
      $buyer:BuyerInput!,
      $internationalCardConversionFee: String
    ) {
      ticket {
        purchase(
          ticketComponents: $ticketComponents
          ticketCode: $ticketCode
          promoterId: $promoterId
          chargeData: { provider: "stripe", token: $stripeToken, id:""}
          eventId:$eventId
          buyer:$buyer
          internationalCardConversionFee:$internationalCardConversionFee
        )
      }
    }

  `;
}

export function purchaseFree() {
  return `
    mutation(
      $ticketComponents: [TicketComponentMinimal!]!
      $eventId:String!,
      $ticketCode: String,
      $promoterId: String,
      $buyer:BuyerInput!,
    ) {
      ticket {
        purchase(
          ticketComponents: $ticketComponents
          ticketCode: $ticketCode
          promoterId: $promoterId
          eventId:$eventId
          buyer:$buyer
        )
      }
    }

  `;
}

export function purchasePrivate() {
  return `
    mutation(
      $code: String
      $ticketComponents: [TicketComponentMinimal!]!
      $stripeToken: String!,
      $eventId:String!,
      $fullName:String!,
      $email:String!
    ) {
      ticket {
        purchase(
          ticketCode: $code
          ticketComponents: $ticketComponents
          chargeData: { provider: "stripe", token: $stripeToken, id:""}
          eventId:$eventId
          buyer:{fullName:$fullName, email:$email}
        )
      }
    }

  `;
}



// WEBPACK FOOTER //
// ./src/components/graphql/queries/ticket.ts